import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAuthService } from '../../../services/api-auth.service';

declare var $: any;

@Component({
  selector: 'app-verificar',
  templateUrl: './verificar.component.html',
  styleUrls: ['./verificar.component.css']
})
export class VerificarComponent implements OnInit {
  correo: string = ''; //Guarda el correo del que se esta verificando
  token: string = ''; //Guarda el token que se recibio en la url por correo
  mensaje: string = ''; //Guardar el mensaje de exito de verificación
  icono: string = ''; //Guardar el icono de exito o error, depende si la verificacion fue exitosa o no

  constructor(private router: Router, private apiAuth: ApiAuthService) {
    let token = this.router.routerState.snapshot.root.children[0].params.token;
    let id = this.router.routerState.snapshot.root.children[0].params.id; //id -> si es 0 entrara a checar el token y activar el usuario, en caso que sea 1, refrescara el token y activara el usuario
    this.token = token;
    /*if (id === '0')
    {*/
      //checaToken => Revisa que el token leído aun este vigente y no haya sido usado.
    this.apiAuth.verificaToken(token).subscribe(data => {
          if (data[0].success) {
                if (data[0].info === '0') {
                  this.icono = 'mdi-email-check-outline uaa-icn-success';
                  this.mensaje = 'Su correo  ha sido verificado exitosamente, ahora puede ingresar a la aplicación.';
                } else {
                  this.icono = 'mdi-close-circle-outline uaa-icn-error';
                  this.mensaje = 'Ha ocurrido un error al verificar su correo.';
                }
              } else {
                this.icono = 'mdi-close-circle-outline uaa-icn-error';
                this.mensaje = 'Ha ocurrido un error al verificar su correo.';
              }

      },
      error => {
        this.router.navigate(['/not-found']);
      });

   /* } else {
      //refrescaToken => Se encarga de refrescar el token que ya termino su vigencia.
      this.apiAuth.refrescaToken(token).subscribe(data => {
        if (data[0].success && data[0].info != '{}') {
          let respuesta = JSON.parse(data[0].info);
          this.correo = respuesta[0].CORREO;
          if (respuesta[0].INDEST !== '0'){
              this.router.navigate(['/not-found']);
          } else {
            //activarUsuario => Activación del usuario
            this.apiAuth.activarUsuario(this.token).subscribe(data => {
              if (data[0].success) {
                if (data[0].info === '0') {
                  this.icono = 'mdi-email-check-outline uaa-icn-success';
                  this.mensaje = 'Su correo '+ this.correo +' ha sido verificado exitosamente, ahora puede ingresar a la aplicación.';
                } else {
                  this.icono = 'mdi-close-circle-outline uaa-icn-error';
                  this.mensaje = 'Ha ocurrido un error al verificar su correo.';
                }
              } else {
                this.icono = 'mdi-close-circle-outline uaa-icn-error';
                this.mensaje = 'Ha ocurrido un error al verificar su correo.';
              }
            },
            error => {
                this.icono = 'mdi-close-circle-outline uaa-icn-error';
                this.mensaje = 'Ha ocurrido un error al verificar su correo.';
            });
          }
        } else {
          this.router.navigate(['/not-found']);
        }
      },
      error => {
        this.router.navigate(['/not-found']);
      });
      this.apiAuth.checaToken(token).subscribe(data => {
        if (data[0].success) {
              if (data[0].info === '0') {
                this.icono = 'mdi-email-check-outline uaa-icn-success';
                this.mensaje = 'Su correo  ha sido verificado exitosamente, ahora puede ingresar a la aplicación.';
              } else {
                this.icono = 'mdi-close-circle-outline uaa-icn-error';
                this.mensaje = 'Ha ocurrido un error al verificar su correo.';
              }
            } else {
              this.icono = 'mdi-close-circle-outline uaa-icn-error';
              this.mensaje = 'Ha ocurrido un error al verificar su correo.';
            }

    },
    error => {
      this.router.navigate(['/not-found']);
    });
    }*/


  }

  ngOnInit() {
  }

}
